import { TEmbListType, TEmbReceiveLogListingDetailItem, TEmbLandingViewDescriptor, TFilterEmb } from '@monorepo/types';
import { ModifiersZTableModel } from '../../../table.modifier';
import { TTableCellTree, TTextCell } from '../../../table.type';
import { UiFilterModifiers } from '../../../../../filter/model/ui-filter.modifier';
import { TFilterGroupModel } from '../../../../../filter/model/ui-filter.types';

type THeader = {
  v: string;
  d: string;
};

const createEmbOutHeaderRow = (table_header: THeader[], list_type: TEmbListType): TTextCell[] => {
  const HeaderRow = [
    ...table_header.map((field) => ({
      type: 'TEXT_CELL',
      text: field.d,
    })),
    {
      type: 'TEXT_CELL',
      text: 'emb_common.EMB_SENT_QTY',
      stickyType: 'RIGHT',
    },
    {
      type: 'TEXT_CELL',
      text: 'emb_common.EMB_DISPATCHED_QTY',
      stickyType: 'RIGHT',
    },
    ...(list_type === 'TRANSACTION_LOG'
      ? [
          {
            type: 'TEXT_CELL',
            text: 'emb_common.ACTION',
            stickyType: 'RIGHT',
          } as TTextCell,
          {
            type: 'TEXT_CELL',
            text: 'emb_common.ACTION',
            stickyType: 'RIGHT',
          } as TTextCell,
        ]
      : []),
  ] as TTextCell[];
  return HeaderRow;
};

const createRowItems = (
  item: TEmbReceiveLogListingDetailItem,
  table_header: THeader[],
  list_type: TEmbListType,
  vendor_key: TEmbLandingViewDescriptor['vendor_key'],
  venderName: string,
): TTableCellTree[] => {
  const itemKeyToValueMap = item.tagDetails.reduce((acc, curr) => {
    acc[curr.k] = curr.v;
    return acc;
  }, {} as Record<string, string>);

  return [
    ...table_header.map((field) => ({
      type: 'TEXT_CELL',
      text: field.v === vendor_key ? venderName : itemKeyToValueMap[field.v] || '--',
    })),
    {
      type: 'TEXT_CELL',
      text: item.sentQty,
    },
    {
      type: 'TEXT_CELL',
      text: item.dispatchedQty.ftt + item.dispatchedQty.rectified,
    },
    ...(list_type === 'TRANSACTION_LOG'
      ? [
          {
            type: 'ACTION_CELL',
            actionType: 'EDIT',
            actionNotAllowed: item.dispatchedQty.ftt + item.dispatchedQty.rectified === item.sentQty,
          },
          {
            type: 'ACTION_CELL',
            actionType: 'DELETE',
          },
        ]
      : []),
  ] as TTableCellTree[];
};

export const EMB_OUT_LOS_LISITNG_DETAILS = {
  createFilterModel: (items: TFilterEmb[], prevModel?: TFilterGroupModel<TFilterEmb>) => {
    const createdNewFilterModel = UiFilterModifiers.createFilterModelList(items, (item) => {
      return {
        type: 'SELECT_FILTER',
        key: item.filterType,
        displayName: item.displayName || item.filterType,
        items: item.values.map((val) => ({
          value: val,
          isSelected: false,
        })),
        selectedValues: [],
      };
    });
    return prevModel
      ? UiFilterModifiers.updateFilterModelList(createdNewFilterModel, prevModel)
      : createdNewFilterModel;
  },
  createTableModel: (
    records: TEmbReceiveLogListingDetailItem[],
    vendor_key: TEmbLandingViewDescriptor['vendor_key'],
    table_header: THeader[],
    list_type: TEmbListType,
    venderName: string,
  ) => {
    return ModifiersZTableModel.createTableModel(
      records,
      {
        headerConfig: createEmbOutHeaderRow(table_header, list_type),
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: createRowItems(item, table_header, list_type, vendor_key, venderName).map((cell) => ({
            ...cell,
          })),
        };
      },
    );
  },
};
